<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/association/detail/'+provider?.id ">chevron_left</mat-icon>
            <h1 class="page-title">{{ !isEdit ? 'Add New Activity' : 'Edit Activity' }}</h1>
        </div>

        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/association'">Associations</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/association/detail/' + provider?.id">{{provider?.providerName}}</span>
            <span class="breadcrumb-separator mx-2" *ngIf="isEdit">/</span>
            <span class="breadcrumb-item" *ngIf="isEdit">{{providerActivity?.activityType}}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">{{ !isEdit ? 'Add New ' : 'Edit ' }}</span>
        </div>
    </div>

    <hr class="mb-3" />

    <form [formGroup]="form">

            <div class="row mt-3">
                <div class="col-12">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>Activity Type</mat-label>
                        <input type="text" matInput formControlName="activityType">
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>Activity Completion Question</mat-label>
                        <input type="text" matInput formControlName="completionQuestion">
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-6">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>CEU Value</mat-label>
                        <input type="text" matInput formControlName="ceuValue">
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field appearance="outline" class="full-width w-100" >
                        <mat-label>Unit Base</mat-label>
                        <mat-select formControlName="unitBase">
                            <mat-option *ngFor="let param of unitBases.parameterMembers" [value]="param.parameterValue">
                                {{ param.parameterLabel }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12">
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Note</mat-label>
                        <textarea rows="10" matInput placeholder="Note" formControlName="note"></textarea>
                    </mat-form-field>
                </div>
            </div>

            <hr class="mb-2" />
        <h5 style="font-size: 16px" class="mt-3 text-white">Condition</h5>
        <mat-accordion class="mb-5" multi formArrayName="conditions">
            <mat-expansion-panel [expanded]="true" *ngFor="let condition of conditions().controls; let j = index" [formGroupName]="j">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="title-container">
                            <span>Condition {{ j + 1 }}</span>
                            <mat-icon (click)="removeCondition(0, j); $event.stopPropagation()" class="button-flat crimson-red">delete</mat-icon>
                        </div>

                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="p-1 expansion-body">
                    <div class="row mt-3">
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Condition Name</mat-label>
                                <input type="text" matInput formControlName="conditionName">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-12">
                            <mat-form-field appearance="outline" class="full-width w-100" >
                                <mat-label>Condition Type</mat-label>
                                <mat-select formControlName="conditionType" (selectionChange)="changeConditionType($event, j)">
                                    <mat-option *ngFor="let param of conditionTypes.parameterMembers" [value]="param.parameterValue">
                                        {{ param.parameterLabel }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row mt-2" *ngIf="condition.get('conditionType')?.value == 'BOOLEAN'">
                        <div class="col-6" >
                            <label class="label-radio text-color-black-normal-50">Value If Valid</label>
                            <mat-radio-group formControlName="valueIfValid" class="status-radio-group">
                                <mat-radio-button [value]="'true'">True</mat-radio-button>
                                <mat-radio-button [value]="'false'">False</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row mt-3" *ngIf="condition.get('conditionType')?.value == 'INTEGER'">
                        <div class="col-6" >
                            <mat-form-field appearance="outline" class="full-width w-100" >
                                <mat-label>Comparison</mat-label>
                                <mat-select formControlName="integerLogic">
                                    <mat-option *ngFor="let param of integerLogics.parameterMembers" [value]="param.parameterValue">
                                        {{ param.parameterLabel }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6" >
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Value If Valid</mat-label>
                                <input class="text-end" type="number" matInput formControlName="valueIfValid">
                            </mat-form-field>
                        </div>
                    </div>


                </div>


            </mat-expansion-panel>
        </mat-accordion>

        <div class="p-1 text-center">
            <div class="d-inline-flex mt-2 gap-3 add-new-activity button-flat" (click)="addCondition(0)">
                <mat-icon class="gap-2">add</mat-icon><span class="d-block mt-1">Add More Condition</span>
            </div>
        </div>

        <div class="row my-5">
            <div class="col-12 text-end">
                <button mat-raised-button (click)="saveActivity()" class="edit-button">Save</button>
            </div>
        </div>
    </form>
</div>
